module.exports = __webpack_public_path__ + "img/money.bf0efaae.svg";